import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import Modal from '../common/Modal';
import Button from '../common/Button';
import Loading from '../common/Loading';

const AssignOwnerModal = ({ association, onClose, onSuccess }) => {
  const [owners, setOwners] = useState([]);
  const [selectedOwnerId, setSelectedOwnerId] = useState('');
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    fetchOwners();
  }, []);

  const fetchOwners = async () => {
    try {
      const response = await api.get('/owners');
      setOwners(response.data.data);
      
      // Pré-sélectionner le owner actuel s'il existe
      if (association.ownerId) {
        setSelectedOwnerId(association.ownerId._id || association.ownerId);
      }
    } catch (error) {
      console.error('Erreur:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleAssign = async () => {
    if (!selectedOwnerId) {
      alert('Veuillez sélectionner un Owner');
      return;
    }

    setSubmitting(true);
    try {
      await api.patch(`/associations/${association._id}/assign-owner`, {
        ownerId: selectedOwnerId,
      });
      alert('Owner assigné avec succès');
      onSuccess();
    } catch (error) {
      alert(error.response?.data?.message || 'Erreur lors de l\'assignation');
    } finally {
      setSubmitting(false);
    }
  };

  const handleUnassign = async () => {
    if (!window.confirm('Retirer le Owner de cette association ?')) {
      return;
    }

    setSubmitting(true);
    try {
      await api.patch(`/associations/${association._id}/unassign-owner`);
      alert('Owner retiré avec succès');
      onSuccess();
    } catch (error) {
      alert(error.response?.data?.message || 'Erreur');
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) return <Modal isOpen={true} onClose={onClose} title="Chargement..."><Loading /></Modal>;

  return (
    <Modal isOpen={true} onClose={onClose} title="👤 Assigner un Owner">
      <div className="space-y-4">
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
          <p className="text-sm text-gray-700">
            <strong>Association :</strong> {association.name}
          </p>
          <p className="text-sm text-gray-600 mt-1">
            {association.description || 'Aucune description'}
          </p>
        </div>

        {/* Sélection Owner */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Sélectionner un Owner
          </label>
          <select
            value={selectedOwnerId}
            onChange={(e) => setSelectedOwnerId(e.target.value)}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-primary"
          >
            <option value="">-- Aucun Owner (géré par Admin) --</option>
            {owners.map((owner) => (
              <option key={owner._id} value={owner._id}>
                {owner.name} ({owner.email})
              </option>
            ))}
          </select>
        </div>

        {owners.length === 0 && (
          <p className="text-sm text-red-600">
            Aucun Owner disponible. Créez-en un d'abord.
          </p>
        )}

        {/* Current Owner */}
        {association.ownerId && (
          <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-3">
            <p className="text-sm text-gray-700">
              <strong>Owner actuel :</strong>{' '}
              {association.ownerId.name || 'N/A'}
            </p>
          </div>
        )}

        {/* Boutons */}
        <div className="flex space-x-3 pt-4 border-t">
          {association.ownerId && (
            <Button
              variant="danger"
              onClick={handleUnassign}
              disabled={submitting}
              className="flex-1"
            >
              {submitting ? 'En cours...' : '❌ Retirer Owner'}
            </Button>
          )}
          <Button
            onClick={handleAssign}
            disabled={submitting || !selectedOwnerId}
            className="flex-1"
          >
            {submitting ? 'En cours...' : '✅ Assigner'}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default AssignOwnerModal;